import type { BundledPackageStateToVehicleId } from "@b2bportal/core-packages";
import { type ExternalResource, CallState } from "@b2bportal/core-types";
import type { ThunkErrorType } from "@b2bportal/core-utilities";
import type { PackageRoom } from "@b2bportal/packages-api";
import { createSlice } from "@reduxjs/toolkit";
import { fetchPackageCarsAvailability } from "./thunks/fetchPackageCarsAvailability";

export type TPackagesByRateId = {
  packagesByRateId: { [key: string]: PackageRoom };
};

export type PackageCarsState = {
  availability: ExternalResource<
    { packageStateByVehicleId: BundledPackageStateToVehicleId },
    ThunkErrorType<{ error: string }>
  >;

  shop: ExternalResource<TPackagesByRateId, ThunkErrorType<{ error: string }>>;
};

export const initialCarsState: PackageCarsState = {
  availability: { state: CallState.NotCalled },
  shop: { state: CallState.NotCalled },
};

export const packageCarsSlice = createSlice({
  name: "package/cars",
  initialState: initialCarsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackageCarsAvailability.pending, (state) => {
        state.availability.state = CallState.InProcess;
      })
      .addCase(fetchPackageCarsAvailability.fulfilled, (state, action) => {
        state.availability.state = CallState.Success;
        state.availability.data = action.payload;
      })
      .addCase(fetchPackageCarsAvailability.rejected, (state) => {
        state.availability.state = CallState.Failed;
      });
  },
});

export const PackageCarsActions = packageCarsSlice.actions;
export default packageCarsSlice.reducer;
